var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "600px",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "100px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "货位编号", prop: "Code" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入货位编号" },
                        model: {
                          value: _vm.form.Code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "货位名称", prop: "Name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入货位名称" },
                        model: {
                          value: _vm.form.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Name", $$v)
                          },
                          expression: "form.Name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "库区", prop: "AreaId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择库区", filterable: "" },
                          on: { change: _vm.getRackList },
                          model: {
                            value: _vm.form.AreaId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "AreaId", $$v)
                            },
                            expression: "form.AreaId",
                          },
                        },
                        _vm._l(_vm.LanewayList, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.Id,
                              attrs: { value: item.Id, label: item.Name },
                            },
                            [_vm._v(_vm._s(item.Name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "货架", prop: "RackId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择货架", filterable: "" },
                          model: {
                            value: _vm.form.RackId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "RackId", $$v)
                            },
                            expression: "form.RackId",
                          },
                        },
                        _vm._l(_vm.RackList, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.Id,
                              attrs: { value: item.Id, label: item.Name },
                            },
                            [_vm._v(_vm._s(item.Name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "IsForbid" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.IsForbid,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "IsForbid", $$v)
                            },
                            expression: "form.IsForbid",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("启用"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("停用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }